module.exports = __webpack_public_path__ + "img/home_bgv3.e07c8e17.png";